/** Input for building the platform set-permission request body. */
export type PermissionFormState = {
  advanced: boolean;
  preset: string;
  select: string;
  insert: string;
  update: string;
  delete: string;
  ownerColumn?: string;
  selectUsing?: string;
  insertCheck?: string;
  updateUsing?: string;
  updateCheck?: string;
  deleteUsing?: string;
};

/**
 * Builds the JSON body for PUT .../permissions/{table}.
 * Preset mode sends only preset (+ optional owner_column).
 * Advanced mode sends per-op levels and custom expression fields when level is "custom".
 */
export function buildPermissionBody(
  s: PermissionFormState,
): Record<string, unknown> {
  if (!s.advanced) {
    return {
      preset: s.preset,
      owner_column: s.ownerColumn || undefined,
    };
  }
  const body: Record<string, unknown> = {
    select: s.select,
    insert: s.insert,
    update: s.update,
    delete: s.delete,
    owner_column: s.ownerColumn || undefined,
  };
  if (s.select === "custom" && s.selectUsing?.trim()) {
    body.select_using = s.selectUsing.trim();
  }
  if (s.insert === "custom" && s.insertCheck?.trim()) {
    body.insert_check = s.insertCheck.trim();
  }
  if (s.update === "custom") {
    if (s.updateUsing?.trim()) body.update_using = s.updateUsing.trim();
    if (s.updateCheck?.trim()) body.update_check = s.updateCheck.trim();
  }
  if (s.delete === "custom" && s.deleteUsing?.trim()) {
    body.delete_using = s.deleteUsing.trim();
  }
  return body;
}
